import { render, staticRenderFns } from "./annotation-list-item-add-comment.vue?vue&type=template&id=68978adc"
import script from "./annotation-list-item-add-comment.vue?vue&type=script&lang=js"
export * from "./annotation-list-item-add-comment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports